/**
 * Module « déblocage » — la console de régie du tenant (SPEC-BOUTIQUE §7).
 *
 * Cinq écrans montés sous `/admin/regie` par le routeur de la fondation, tous
 * réservés au rôle **administrateur** :
 *
 *   /admin/regie/sieges       DEB-01 diagnostic · DEB-03 (une date) · DEB-04 · DEB-05
 *   /admin/regie/abonnements  DEB-03 (toute la série) · DEB-07
 *   /admin/regie/paniers      DEB-06
 *   /admin/regie/phases       DEB-09
 *   /admin/regie/abonne       DEB-12
 *
 * DEB-02 (journal d’audit filtrable) vit dans les tableaux de bord, où le
 * journal est déjà servi ; DEB-08 et DEB-11 (rééditer un document, corriger un
 * paiement) sont les écrans de souscription, de vente et de paiement, où le
 * geste appartient à l’objet qu’il corrige. La régie ne les duplique pas.
 *
 * ★ Chargement paresseux : ces écrans ne servent que quelques fois par mois et
 * tirent `SeatMap` avec eux. Ils n’ont rien à faire dans le lot initial que
 * télécharge le guichet chaque matin.
 */

import { lazy } from 'react'
import type { RouteObject } from 'react-router'
import { Navigate } from 'react-router'

import { EcranSansObjet } from '../../components/EcranSansObjet'
import { LayoutRegie } from './LayoutRegie'
import { CHEMIN_DIAGNOSTIC } from './chemins'

const PageDiagnostic = lazy(() =>
  import('./PageDiagnostic').then((m) => ({ default: m.PageDiagnostic })),
)
const PageAbonnements = lazy(() =>
  import('./PageAbonnements').then((m) => ({ default: m.PageAbonnements })),
)
const PagePaniersRegie = lazy(() =>
  import('./PagePaniersRegie').then((m) => ({ default: m.PagePaniersRegie })),
)
const PagePhases = lazy(() => import('./PagePhases').then((m) => ({ default: m.PagePhases })))
const PageEspaceAbonne = lazy(() =>
  import('./PageEspaceAbonne').then((m) => ({ default: m.PageEspaceAbonne })),
)
const PageInterventions = lazy(() =>
  import('./PageInterventions').then((m) => ({ default: m.PageInterventions })),
)

export const routesDeblocage: RouteObject[] = [
  {
    element: <LayoutRegie />,
    children: [
      { index: true, element: <Navigate to={CHEMIN_DIAGNOSTIC} replace /> },
      { path: 'sieges', element: <PageDiagnostic /> },
      /* ★ EVT-04 — DEB-03/DEB-07 et DEB-12 ont l'abonnement pour SUJET : la
         série qu'on déplace, la carte qu'on transfère, l'espace qu'on consulte
         pour dépanner un abonné au téléphone. Un tenant `evenement` n'a ni
         formule ni souscription (EVT-02) — il n'y a rien à y reformuler, il n'y
         a qu'à ne pas y conduire. Les onglets de `LayoutRegie` les retirent
         déjà ; ce renvoi ferme l'adresse tapée ou gardée en signet. */
      {
        path: 'abonnements',
        element: (
          <EcranSansObjet vers={CHEMIN_DIAGNOSTIC}>
            <PageAbonnements />
          </EcranSansObjet>
        ),
      },
      { path: 'paniers', element: <PagePaniersRegie /> },
      { path: 'phases', element: <PagePhases /> },
      { path: 'demandes', element: <PageInterventions /> },
      {
        path: 'abonne',
        element: (
          <EcranSansObjet vers={CHEMIN_DIAGNOSTIC}>
            <PageEspaceAbonne />
          </EcranSansObjet>
        ),
      },
    ],
  },
]

export {
  CHEMIN_ABONNEMENTS,
  CHEMIN_DIAGNOSTIC,
  CHEMIN_ESPACE_ABONNE,
  CHEMIN_PANIERS_REGIE,
  CHEMIN_PHASES,
  CHEMIN_REGIE,
} from './chemins'
